import { GET_UNIT, GET_UNIT_SLUG_CONDITION, GET_UNIT_DATA, NEW_UNIT_INIT, SAVE_UNIT_DATA, UNIT_SCAN_IND_SET } from '../constants';
import DlUnit from '../models/DlUnit';
import { updateObject, createReducer } from './common';
import { indArrNorm } from '../common';


export const initialState = { 
    dlUnitId: '', 
    dlUnit: new DlUnit(),
    scanInd: 0     
};

const unitScanIndSet = (state, action) => {
    let scanInd = action.payload;
    const n = ( state.dlUnit.hasOwnProperty('scans') ? state.dlUnit.scans.length : 0 );
    scanInd = indArrNorm(scanInd, n);
    if (state.scanInd != scanInd) {
        return updateObject(state, { scanInd });        
    } else {
        return state;
    }
}

const handler = {
    [GET_UNIT]: (state, action) => updateObject(state, { dlUnitId: action.payload, dlUnit: new DlUnit() }),
    [GET_UNIT_SLUG_CONDITION]: (state, action) => updateObject(state, { dlUnitId: '', dlUnit: new DlUnit() }),
    [GET_UNIT_DATA]: (state, action) => updateObject(state, { dlUnitId: action.payload.id, dlUnit: action.payload }),
    [NEW_UNIT_INIT]: () => ({ ...initialState }),
    [SAVE_UNIT_DATA]: (state, action) => updateObject(state, { dlUnitId: action.payload, dlUnit: new DlUnit() }),
    [UNIT_SCAN_IND_SET]: unitScanIndSet
}

export const dlUnitReducer = createReducer(initialState, handler);